<template>
  <div>
    <van-nav-bar :left-text="$t('button.return')" :right-text="username" :title="title" left-arrow @click-left="onClickLeft" @click-right="goIndex()"/>
    <van-cell-group>
      <van-field ref="barcode" :label="$t('business.label.barcode')" autofocus clearable left-icon="photograph" placeholder="请扫描条码" @keydown.native.enter="(e)=>review(e.target.value)"/>
    </van-cell-group>
    <vxe-table ref="list" :data="list" :loading="loading">
      <vxe-column title="business.label.review" width="60">
        <template #default="{row}">
          <vxe-switch v-model:value="row.command.commandStatus>=43"/>
        </template>
      </vxe-column>
      <vxe-column field="customer.shortName" title="business.label.customer"/>
      <vxe-column field="barcode.no" title="business.label.barcode" width="100"/>
      <vxe-column field="item.name" title="business.label.item"/>
    </vxe-table>
    <van-tabbar fixed placeholder>
      <van-tabbar-item>
        <van-row gutter="20">
          <van-col span="20">
            <van-button :loading="loading" block native-type="review" round style="margin: 10px;" type="info" @click="review">复核</van-button>
          </van-col>
        </van-row>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import api from '@/api'
import { findAll, post } from '@/api/Api'
import { getUser } from '@/pdaView/utils'
import { Toast } from 'vant'

export default {
  data() {
    return {
      loading: false,
      username: getUser().name,
      list: [],
      title: undefined
    }
  },
  activated() {
    this.title = this.$route.params.barcode
    this.refresh()
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    goIndex() {
      this.$router.push({ name: 'PdaIndex' })
    },
    refresh() {
      this.loading = true
      findAll('reviewCommandAreaFactory', { 'stagingArea': this.$route.params.barcode }).then(res => {
        if (res.success) {
          this.list = res.result
          if (this.list.length === 0) this.onClickLeft()
        } else {
          this.onClickLeft()
        }
      }).finally(() => this.loading = false)
    },
    review(value) {
      if (value) {
        this.loading = true
        post(api.reviewReview, {}, { 'barcode.no': value }).then(res => {
          if (res.success) {
            Toast('复核成功！')
            this.refresh()
          }
        }).finally(() => this.loading = false)
      } else {
        Toast('请先输入条码')
      }
    }
  }
}
</script>